import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram } from 'lucide-react';
import { brand, navLinks, products, waLink, waLinkProps } from '../mock';
import WhatsAppIcon from './WhatsAppIcon';
import ThemeToggle from './ThemeToggle';
import Logo3D from './Logo3D';
import { trackWhatsAppClick } from '../lib/analytics';

const categoryCount = (path) => {
  const category = path.replace('/', '');
  return products.filter((p) => p.category === category).length;
};

const Landing = () => {
  return (
  <div className="q-landing" data-testid="landing-page">
    <div className="q-landing__marks" aria-hidden="true">
      <img src={brand.logoStatic} alt="" className="q-landing__mark q-landing__mark--tl" draggable={false} />
      <img src={brand.logoStatic} alt="" className="q-landing__mark q-landing__mark--br" draggable={false} />
      <img src={brand.logoStatic} alt="" className="q-landing__mark q-landing__mark--bl" draggable={false} />
      <img src={brand.logoStatic} alt="" className="q-landing__mark q-landing__mark--mid" draggable={false} />
    </div>

    <ThemeToggle className="q-landing__theme-toggle" />
    <div className="q-landing__inner">
      <div className="q-landing__logo">
        <Logo3D />
      </div>
      <h1 className="q-landing__brand" data-testid="landing-brand">{brand.name}</h1>
      <p className="q-landing__tagline">{brand.tagline}</p>

      <nav className="q-landing__menu" aria-label="Categorías">
        {navLinks.map((l) => {
          const count = categoryCount(l.path);
          return (
            <Link
              key={l.path}
              to={l.path}
              className="q-btn q-btn--ghost q-btn--block"
              data-testid={`landing-link-${l.label.toLowerCase()}`}
            >
              {l.label}{count > 0 ? ` · ${count}` : ''}
            </Link>
          );
        })}
      </nav>

      <div className="q-landing__socials">
        <a
          href={waLink('Hola QUINLATE, quiero información sobre sus piezas.')}
          {...waLinkProps}
          className="q-landing__social"
          data-testid="landing-whatsapp"
          aria-label="WhatsApp"
          onClick={() => trackWhatsAppClick('landing')}
        >
          <WhatsAppIcon size={20} />
        </a>
        <a
          href="https://www.instagram.com/quinlate.joyeros/"
          target="_blank"
          rel="noopener noreferrer"
          className="q-landing__social"
          data-testid="landing-instagram"
          aria-label="Instagram"
        >
          <Instagram size={20} strokeWidth={1.5} />
        </a>
      </div>
    </div>
  </div>
  );
};

export default Landing;
